<template>
  <div>
    <b-row>
      <b-col sm="3">
        <DateTime title="Data Início" field="dateStart" format="DD/MM/YYYY" type="date" :required="true" placeholder
          :formName="formName" :markFormDirty="false" :disabled="disabled" v-model="team.dateStart" />
      </b-col>
      <b-col sm="3">
        <DateTime title="Hora" field="timeStart" format="HH:mm" :required="true" type="time" placeholder
          :formName="formName" :markFormDirty="false" :disabled="disabled" v-model="team.timeStart" />
      </b-col>
      <b-col sm="3">
        <DateTime title="Data Fim" field="dateEnd" format="DD/MM/YYYY" type="date" :required="true" placeholder
          :formName="formName" :markFormDirty="false" :disabled="disabled" v-model="team.dateEnd" />
      </b-col>
      <b-col sm="3">
        <DateTime title="Hora" field="timeEnd" format="HH:mm" type="time" :required="true" placeholder
          :formName="formName" :markFormDirty="false" :disabled="disabled" v-model="team.timeEnd" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">
        <DateTime title="Data Pagamento" field="dueDate" format="DD/MM/YYYY" type="date" :required="false" placeholder
          :formName="formName" :markFormDirty="false" :disabled="disabled" v-model="team.dueDate" />
      </b-col>
      <b-col sm="4">
        <div class="team-period-value-field">
          <InputDecimal title="Valor/Cachê" field="value" :formName="formName" :required="false"
            :markFormDirty="false" :disabled="disabled || isLoading(refreshKey)" v-model="team.value" />
          <div v-if="!disabled" class="team-period-value-refresh">
            <Button :_key="refreshKey" tooltip="Atualizar valor" type="primary" size="small"
              classIcon="fa-solid fa-rotate-right" :clicked="calculateValue" />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/ui/forms/DateTime";
import InputDecimal from "@/ui/forms/InputDecimal";
import Button from "@/ui/forms/Button";

import TeamService from "../services/team.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TeamPeriodValue",
  components: { DateTime, InputDecimal, Button },
  props: {
    team: {
      type: Object,
      required: true,
    },
    formName: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("generic", ["isLoading"]),
    refreshKey() {
      return `btnRefreshTeamValue_${this.formName}`;
    },
  },
  methods: {
    ...mapMutations("generic", ["addLoading", "removeLoading"]),
    async calculateValue() {
      this.addLoading(this.refreshKey);
      try {
        const collaboratorId = this.team.collaborator?.id;
        if (!collaboratorId || !this.team.dateStart || !this.team.timeStart || !this.team.dateEnd || !this.team.timeEnd) return;

        const response = await TeamService.calculateValue({
          collaboratorId,
          dateStart: this.team.dateStart,
          timeStart: this.team.timeStart,
          dateEnd: this.team.dateEnd,
          timeEnd: this.team.timeEnd,
        });
        this.team.value = response.data.content.value;
      } finally {
        this.removeLoading([this.refreshKey]);
      }
    },
  },
  watch: {
    "team.timeEnd"(newValue) {
      if (newValue) this.calculateValue();
    },
  },
};
</script>
<style scoped>
.team-period-value-field {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.team-period-value-field >>> .form-group {
  flex: 1;
}

.team-period-value-refresh {
  margin-top: 38px;
}
</style>
